import { render, staticRenderFns } from "./PlanilhaAlteracoes.vue?vue&type=template&id=f142b028&scoped=true"
import script from "./PlanilhaAlteracoes.vue?vue&type=script&lang=js"
export * from "./PlanilhaAlteracoes.vue?vue&type=script&lang=js"
import style0 from "./PlanilhaAlteracoes.vue?vue&type=style&index=0&id=f142b028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f142b028",
  null
  
)

export default component.exports